import React from "react";

function ZonesIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="-0.5 -0.5 26 26">
      <path
        d="M15.5,3A12.5,12.5,0,1,0,28,15.5,12.506,12.506,0,0,0,15.5,3Zm-5,19.377a3.125,3.125,0,1,1,3.125-3.125A3.126,3.126,0,0,1,10.5,22.377ZM12.376,10.5A3.125,3.125,0,1,1,15.5,13.626,3.126,3.126,0,0,1,12.376,10.5ZM20.5,22.377a3.125,3.125,0,1,1,3.125-3.125A3.126,3.126,0,0,1,20.5,22.377Z"
        transform="translate(-3 -3)"
      />
    </svg>
  );
}

export { ZonesIcon };
